import { Reducer } from 'redux';
import { AttributesActionType, IAttributesState, SET_SITE_ATTRIBUTES } from './types/Attributes.d';

const initialState: IAttributesState = {
  isEuUser: false,
  isJoinCaptchaEnabled: false,
  isLoginCaptchaEnabled: false,
  captcha: null,
  cf_country: '',
};

const attributes: Reducer<IAttributesState> = (state = initialState, action: AttributesActionType): any => {
  if (action.type === SET_SITE_ATTRIBUTES) {
    return {
      ...state,
      ...action.payload,
    };
  }

  return state;
};

export default attributes;
